import React from 'react'
import { IconType } from 'react-icons'
import {
    FaClock,
    FaCheck,
    FaX,
    FaCircleMinus,
    FaCalendarXmark,
} from 'react-icons/fa6'
import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react'
import {
    PatientPimsReminderFieldsFragment,
    PimsReminder,
} from '~graphql/generated/graphql'

interface Props {
    reminder: Pick<
        PimsReminder,
        'is_active' | 'is_completed' | 'send_date' | 'display_due_date'
    >
}

enum ReminderStatus {
    Completed = 'Completed',
    Upcoming = 'Upcoming',
    Cancelled = 'Cancelled',
    Missed = 'Missed',
    NoDueDate = 'No Due Date',
}

export default function ReminderStatusTag({ reminder }: Props) {
    const { is_completed, is_active, send_date, display_due_date } = reminder

    const noDueDate = !display_due_date && !send_date
    const effectiveDueDate = display_due_date || send_date
    const isPast = !!effectiveDueDate && effectiveDueDate < new Date().getTime()

    const status = getStatus(isPast, is_completed, is_active, noDueDate)
    const colorScheme = getColor(status)
    const icon = getIcon(status)

    return (
        <Tag colorScheme={colorScheme} size="sm">
            <TagLeftIcon as={icon} />
            <TagLabel>{status}</TagLabel>
        </Tag>
    )
}

function getStatus(
    isPast: boolean,
    isCompleted: boolean,
    isActive: boolean,
    noDueDate: boolean,
): ReminderStatus {
    if (noDueDate) {
        return ReminderStatus.NoDueDate
    }

    if (isPast) {
        if (isCompleted) {
            return ReminderStatus.Completed
        }

        return ReminderStatus.Missed
    } else {
        if (isActive) {
            return ReminderStatus.Upcoming
        }

        return ReminderStatus.Cancelled
    }
}

function getColor(status: ReminderStatus): string {
    switch (status) {
        case ReminderStatus.Completed:
            return 'green'
        case ReminderStatus.Upcoming:
            return 'blue'
        case ReminderStatus.Cancelled:
            return 'gray'
        case ReminderStatus.Missed:
            return 'red'
        case ReminderStatus.NoDueDate:
            return 'gray'
    }
}

function getIcon(status: ReminderStatus): IconType {
    switch (status) {
        case ReminderStatus.Completed:
            return FaCheck
        case ReminderStatus.Upcoming:
            return FaClock
        case ReminderStatus.Cancelled:
            return FaCircleMinus
        case ReminderStatus.Missed:
            return FaX
        case ReminderStatus.NoDueDate:
            return FaCalendarXmark
    }
}
